import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'Portfolio', href: '#portfolio' },
  { label: 'About', href: '#about' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? 'bg-[#0a0a0a]/85 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1500px] mx-auto px-3 sm:px-6 lg:px-12 h-28 sm:h-24 md:h-20 lg:h-24 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2 group min-w-0">
          <img
            src="/dm-logo.png"
            alt="Dion Magee Events & Weddings"
            className="w-[72px] h-[72px] sm:w-[68px] sm:h-[68px] md:w-[60px] md:h-[60px] lg:w-[68px] lg:h-[68px] object-contain flex-shrink-0 transition-transform duration-500 group-hover:scale-105"
          />
          <div className="leading-none min-w-0">
            <div className="text-white font-serif text-[30px] sm:text-[26px] md:text-[22px] lg:text-[26px] tracking-[0.08em] sm:tracking-[0.14em] md:tracking-[0.18em] leading-none whitespace-nowrap">
              DION MAGEE
            </div>
            <div className="text-[#c9a96e]/90 text-[12px] sm:text-[11px] md:text-[10px] lg:text-[11px] tracking-[0.18em] sm:tracking-[0.26em] md:tracking-[0.32em] mt-2 sm:mt-1.5 leading-none whitespace-nowrap">
              EVENTS &amp; WEDDINGS
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-white/80 hover:text-[#c9a96e] text-[11px] tracking-[0.3em] uppercase transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            className="text-[#c9a96e] hover:bg-[#c9a96e] hover:text-black px-6 py-3 border border-[#c9a96e]/60 text-[11px] tracking-[0.3em] uppercase transition-colors duration-300"
          >
            Enquire
          </a>
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden relative z-[60] text-white p-2 -mr-2"
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden relative z-[55] bg-[#0a0a0a]/98 backdrop-blur-md border-t border-white/5 px-6 py-6 space-y-5 shadow-2xl">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-white/85 hover:text-[#c9a96e] text-sm tracking-[0.3em] uppercase py-1"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="inline-block text-[#c9a96e] border border-[#c9a96e]/60 px-6 py-3 text-xs tracking-[0.3em] uppercase mt-3"
          >
            Enquire
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
